export default "__VITE_ASSET__DRDCARbd__"